<template>
  <BaseScreen v-bind="screen">
    <BaseMenu
      :items="menuItems"
    />
  </BaseScreen>
</template>

<script>
import screenMixin from '@/mixins/screen';
import doubleReplicMixin from '@/mixins/doubleReplic';
import BaseMenu from '@/components/BaseMenu.vue';

import CONSTANTS from '@/helpers/constants';

const {
  STEP_PHOTO_ACTION_ONE,
  STEP_PHOTO_ACTION_TWO,
  ACTION_ENTERTAINMENT_PHOTO,
} = CONSTANTS;

export default {
  name: 'EntertainmentScreen',
  mixins: [screenMixin, doubleReplicMixin],
  components: {
    BaseMenu,
  },
  computed: {
    menuItems() {
      return [
        'dance',
        'highFive',
        'secondDance',
        'tellStory',
        'photo',
        'shakeHand',
        'showPlane',
        'tellRiddle',
      ].map((name) => {
        const text = this.$t(`actions.${name}`);
        const action = name === 'photo' ? this.startPhotoAction : () => this.setAnswer(text);
        return { text, action };
      });
    },
  },
  created() {
    this.initActions();
  },
  methods: {
    setAnswer(text) {
      return this.$robot.dialogService.setAnswer(text);
    },
    startPhotoAction() {
      return this.sayDoubleReplic(STEP_PHOTO_ACTION_ONE, STEP_PHOTO_ACTION_TWO);
    },
    initActions() {
      const rootActions = [
        [ACTION_ENTERTAINMENT_PHOTO, this.startPhotoAction],
      ];

      rootActions.forEach((action) => this.$root.$on(...action));

      this.$once('hook:beforeDestroy', () => {
        rootActions.forEach((action) => this.$root.$off(...action));
      });
    },
  },
};
</script>
